import React from "react";
import "./Main.css";
import Tab from "../tab/Tab";
import Tab2 from "../tab/Tab2";
import Tab3 from "../tab/Tab3";
import Footer from "../Footer/Footer";
const Main = ({main}) => {
  return (
    <>
      <div className="main-body">
        <Tab main={main}/>
       <br />
       <br />
       <br />
       <br />
       <br />
       <br />
        <Footer />
      </div>
    </>
  );
};

export default Main;
